import { render, staticRenderFns } from "./live-config.vue?vue&type=template&id=7f5af423&"
import script from "./live-config.vue?vue&type=script&lang=js&"
export * from "./live-config.vue?vue&type=script&lang=js&"
import style0 from "./live-config.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports